export const environment = {
  // These are placeholders; values are typically overridden at deploy time.
  // Do NOT put secrets here.
  appInsightsKey: '',
  msalConfig: {},
  production: false,
  environmentName: 'Local',
  lowerenvironment: true,
};
